import { useEffect, useState } from 'react'
import { Navigate, NavLink, useParams } from 'react-router-dom'
import api, { CollectionInfo, Token } from '../api'
import assets from '../assets'
import { CollectionView } from '../components/CollectionView'
import { Page } from '../components/Page'
import { ProgressiveImg } from '../components/ProgressiveImg'
import Spinner from '../components/Spinner'

export default () => {
    const params = useParams()
    if (!['apes', 'droids'].includes(params.name ?? '')) {
        return <Navigate to='/404' />
    }

    const infoImages = {
        apes: [assets.collection_info.ape, assets.collection_info.ape_placeholder],
        droids: [assets.collection_info.droid, assets.collection_info.droid_placeholder],
    }

    const [tokens, setTokens] = useState<Token[]>([])
    const [info, setInfo] = useState<CollectionInfo | undefined>(undefined)
    const [tokensLoaded, setTokensLoaded] = useState(false)

    useEffect(() => {
        api.collection.infoByName(params.name).then((info) => setInfo(info))
        api.collection
            .tokens(params.name)
            .then((tokens) => setTokens(tokens))
            .finally(() => setTokensLoaded(true))
    }, [])

    return (
        <Page title={info?.name ? `${info.name} NFT Collection` : ''}>
            <div className='relative flex flex-col max-w-[1920px] w-full mx-auto'>
                <section className='relative overflow-hidden h-[37.5vw] md:max-h-[25vw]'>
                    {info && (
                        <ProgressiveImg
                            src={infoImages[info.name][0]}
                            placeholder={infoImages[info.name][1]}
                            className='object-cover w-full h-full brightness-50  max-h-[37.5vw] md:max-h-[min(25vw,480px)]'
                        />
                    )}
                    {info && (
                        <div className='absolute z-10 top-0 h-full w-full flex flex-col items-center uppercase'>
                            <div className='hidden md:flex flex-row gap-x-3 self-start text-xs lg:text-base p-2 md:p-4 md:px-8 lg:pt-6'>
                                <NavLink to='/collection'>Collection</NavLink>
                                <div className='opacity-60'> &gt;</div>
                                <div className='opacity-60'> {info.name}</div>
                            </div>
                            <h1 className='font-bold text-4xl md:text-7xl p-4 md:px-8 lg:mt-8'>{info.name}</h1>
                            <div
                                className='flex-1 w-full text-center text-[0.7rem] md:text-base lg:text-xl font-bold p-2 md:p-4 md:px-8 lg:leading-loose'
                                style={{ background: 'linear-gradient(180deg, rgba(21, 18, 24, 0) 0%, #000 100%)' }}
                            >
                                SUPPLY: {info.supply} | LAST MINT: {info.days_since_mint} DAYS AGO
                                <br />
                                MINT PRICE: {info.mint_price} SOL | FLOOR PRICE: {info.floor_price} SOL
                                {/* ROI: <span className={`${info.roi > 0 ? 'text-[#00FF90]' : 'text-[#D40000]'}`}>{info.roi > 0 ? '+' : ''}{info.roi}%</span> */}
                            </div>
                        </div>
                    )}
                </section>

                {!tokensLoaded ? <Spinner className='mx-auto' /> : <CollectionView tokens={tokens} />}
            </div>
        </Page>
    )
}
